import { render, staticRenderFns } from "./WorkflowExpandedTable.vue?vue&type=template&id=e4eec9f8&scoped=true&"
import script from "./WorkflowExpandedTable.vue?vue&type=script&lang=js&"
export * from "./WorkflowExpandedTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowExpandedTable.vue?vue&type=style&index=0&id=e4eec9f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4eec9f8",
  null
  
)

export default component.exports